/**
 * @file useCustomerBlends.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-08-25
 * @modified 2026-08-25
 * @description The customer blend lines, plus the formulations that have none.
 *
 *              Both the organiser and the single-row move dialog need the same
 *              two lists, and both need to reload them after a change. Keeping
 *              the fetch here means neither has to know the endpoint's shape,
 *              and a change made in one is picked up by the other on reload.
 */

import { useState, useEffect, useCallback } from 'react';
import { API_URL } from '../config';

export default function useCustomerBlends({ includeArchived = true } = {}) {
  const [blends, setBlends] = useState([]);
  const [unassigned, setUnassigned] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/formulations/customer-blends?includeArchived=${includeArchived}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Failed to load');
      setBlends(data.blends || []);
      setUnassigned(data.unassigned || []);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [includeArchived]);

  useEffect(() => { load(); }, [load]);

  return { blends, unassigned, loading, error, reload: load };
}
